// components/Header.tsx
'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import NextLink from 'next/link';
import { useEffect, useState } from 'react';
import { useScrollContainer } from '@/app/_lib/providers/ScrollProvider';
import { ThemeAwareLogo } from './ThemeAwareLogo';
interface HeaderProps {
  isInnerPage?: boolean;
}
const Header = t0 => {
  const $ = _c(55);
  const {
    isInnerPage: t1
  } = t0;
  const isInnerPage = t1 === undefined ? false : t1;
  const appName = process.env.NEXT_PUBLIC_APP_NAME || "";
  const facilityTelephone = process.env.NEXT_PUBLIC_FACILITY_TELEPHONE || "";
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    scrollContainerRef
  } = useScrollContainer();
  let t2;
  let t3;
  if ($[0] !== isInnerPage) {
    t2 = () => {
      if (isInnerPage) {
        setIsScrolled(true);
      }
    };
    t3 = [isInnerPage];
    $[0] = isInnerPage;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== scrollContainerRef.current) {
    t4 = () => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
      setIsMobileMenuOpen(false);
    };
    $[3] = scrollContainerRef.current;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const scrollToTop = t4;
  let t5;
  if ($[5] !== isMobileMenuOpen) {
    t5 = () => {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    };
    $[5] = isMobileMenuOpen;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const handleToggleMenu = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setIsMobileMenuOpen(false);
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const removeActiveClass = t6;
  let t7;
  if ($[8] !== isInnerPage || $[9] !== scrollContainerRef.current) {
    t7 = () => {
      if (!isInnerPage && scrollContainerRef.current) {
        const handleScroll = () => {
          const scrollPosition = scrollContainerRef.current?.scrollTop || 0;
          const carousel = document.getElementById("hero-slideshow");
          const carouselHeight = carousel?.offsetHeight || 0;
          setIsScrolled(scrollPosition > carouselHeight);
        };
        const scrollContainer = scrollContainerRef.current;
        scrollContainer.addEventListener("scroll", handleScroll);
        handleScroll();
        return () => {
          scrollContainer.removeEventListener("scroll", handleScroll);
        };
      }
    };
    $[8] = isInnerPage;
    $[9] = scrollContainerRef.current;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== isInnerPage || $[12] !== scrollContainerRef) {
    t8 = [isInnerPage, scrollContainerRef];
    $[11] = isInnerPage;
    $[12] = scrollContainerRef;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      const handleResize = () => {
        if (window.innerWidth > 768) {
          setIsMobileMenuOpen(false);
        }
      };
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    };
    t10 = [];
    $[14] = t10;
    $[15] = t9;
  } else {
    t10 = $[14];
    t9 = $[15];
  }
  useEffect(t9, t10);
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = [{
      id: "about",
      label: "About"
    }, {
      id: "services-and-ammenities",
      label: "Services & Amenities"
    }, {
      id: "mission-and-values",
      label: "Mission & Values"
    }, {
      id: "photo-gallery",
      label: "Photos"
    }, {
      id: "waiver",
      label: "ALW Program"
    }, {
      id: "contact-us",
      label: "Contact"
    }];
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const navItems = t11;
  const navOpacityClass = isScrolled || isInnerPage ? "opacity-100" : "opacity-95";
  let t12;
  if ($[17] !== isInnerPage || $[18] !== scrollToTop) {
    t12 = <div className="flex w-full h-full py-2">{isInnerPage ? <NextLink href="/" aria-label="Return to homepage" className="cursor-pointer hidden md:flex items-center w-full h-full"><ThemeAwareLogo /></NextLink> : <button type="button" aria-label="Return to top of the page" onClick={scrollToTop} className="cursor-pointer hidden md:flex items-center w-full h-full"><ThemeAwareLogo /></button>}{isInnerPage ? <NextLink href="/" className="flex md:hidden items-center cursor-pointer" aria-label="Return to homepage"><div className="relative w-[55px] h-[50px] pr-2 aspect-971/892 flex items-center gap-y-1"><Image src="/logo/new-flower-logo.svg" height={163} width={150} alt={`${appName} flower logo`} sizes="(max-width: 768px) 100vw, 150px" /></div><div><h2 className={`text-xl font-bold mb-0! pb-0! whitespace-nowrap font-serif ${"text-primary dark:text-gray-200"}`}>{appName}</h2></div></NextLink> : <button type="button" className="flex md:hidden items-center cursor-pointer" aria-label="Return to top of the page" onClick={scrollToTop}><div className="relative w-[55px] h-[50px] pr-2 aspect-971/892 flex items-center gap-y-1"><Image src="/logo/new-flower-logo.svg" height={163} width={150} alt={`${appName} flower logo`} sizes="(max-width: 768px) 100vw, 150px" /></div><div><h2 className={`text-xl font-bold mb-0! pb-0! whitespace-nowrap font-serif ${"text-primary dark:text-gray-200"} text-shadow-lg/20`}>{appName}</h2></div></button>}</div>;
    $[17] = isInnerPage;
    $[18] = scrollToTop;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="relative hidden md:flex flex-col items-end mr-6"><a href={`tel:${facilityTelephone.replace(/[^0-9]/g, "")}`} className={`text-3xl font-semibold font-serif ${"text-primary hover:text-primary-dark dark:text-gray-200 dark:hover:text-white"} transition-all duration-200`}>{facilityTelephone}</a></div>;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = isMobileMenuOpen ? "Close main menu" : "Open main menu";
  const t15 = isMobileMenuOpen ? "Close main menu" : "Open main menu";
  let t16;
  if ($[21] !== t15) {
    t16 = <span className="sr-only">{t15}</span>;
    $[21] = t15;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  const t17 = `${isMobileMenuOpen ? "hidden" : "block"} h-6 w-6`;
  let t18;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] !== t17) {
    t19 = <svg className={t17} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden={true}>{t18}</svg>;
    $[24] = t17;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  const t20 = `${isMobileMenuOpen ? "block" : "hidden"} h-6 w-6`;
  let t21;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  let t22;
  if ($[27] !== t20) {
    t22 = <svg className={t20} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden={true}>{t21}</svg>;
    $[27] = t20;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] !== handleToggleMenu || $[30] !== isMobileMenuOpen || $[31] !== t14 || $[32] !== t16 || $[33] !== t19 || $[34] !== t22) {
    t23 = <div className="flex items-center shrink-0 space-x-4">{t13}<div className="flex items-center md:hidden"><button className={`inline-flex items-center justify-center p-2 rounded-md ${"text-primary dark:text-gray-200"} hover:text-white hover:bg-primary focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white`} type="button" aria-controls="mobile-menu" aria-expanded={isMobileMenuOpen} aria-label={t14} onClick={handleToggleMenu}>{t16}{t19}{t22}</button></div></div>;
    $[29] = handleToggleMenu;
    $[30] = isMobileMenuOpen;
    $[31] = t14;
    $[32] = t16;
    $[33] = t19;
    $[34] = t22;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== t12 || $[37] !== t23) {
    t24 = <div className="container mx-auto px-4 sm:px-6 lg:px-8"><div className="flex items-center justify-between h-20 md:h-24">{t12}{t23}</div></div>;
    $[36] = t12;
    $[37] = t23;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  const t25 = `hidden md:block bg-primary dark:bg-gray-800 shadow-md transition-all duration-300 ease-in-out ${navOpacityClass}`;
  let t26;
  if ($[39] !== isInnerPage) {
    t26 = <div className="container mx-auto px-4 sm:px-6 lg:px-8"><div className="flex justify-center items-center h-12"><ul className="flex space-x-1 lg:space-x-2">{navItems.map(item => <li key={item.id}>{isInnerPage ? <NextLink href={`/#${item.id}`} className="text-white hover:text-accent dark:hover:text-primary-light px-3 py-2 rounded-md text-sm font-medium cursor-pointer transition-colors duration-200 inline-block" onClick={removeActiveClass}>{item.label}</NextLink> : <NextLink href={`/#${item.id}`} className="text-white hover:text-accent px-3 py-2 rounded-md text-sm font-medium cursor-pointer transition-colors duration-200 inline-block" onClick={removeActiveClass}>{item.label}</NextLink>}</li>)}</ul></div></div>;
    $[39] = isInnerPage;
    $[40] = t26;
  } else {
    t26 = $[40];
  }
  let t27;
  if ($[41] !== t25 || $[42] !== t26) {
    t27 = <nav className={t25} aria-label="Main navigation">{t26}</nav>;
    $[41] = t25;
    $[42] = t26;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  const t28 = `${isMobileMenuOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0 pointer-events-none"} md:hidden bg-primary/95 dark:bg-gray-800/95 backdrop-blur-sm overflow-hidden transition-all duration-300 ease-in-out`;
  const t29 = !isMobileMenuOpen;
  let t30;
  if ($[44] !== isInnerPage || $[45] !== isMobileMenuOpen) {
    t30 = <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3"><ul className="flex flex-col space-y-2" aria-label="Mobile navigation">{navItems.map(item_0 => <li key={item_0.id}>{isInnerPage ? <NextLink href={`/#${item_0.id}`} className="text-white hover:bg-white/10 dark:hover:bg-gray-700/50 block px-3 py-2 rounded-md text-base font-medium cursor-pointer transition-colors duration-200" onClick={removeActiveClass}>{item_0.label}</NextLink> : <NextLink href={`/#${item_0.id}`} className="text-white hover:bg-white/10 block px-3 py-2 rounded-md text-base font-medium cursor-pointer transition-colors duration-200" onClick={removeActiveClass} tabIndex={isMobileMenuOpen ? 0 : -1}>{item_0.label}</NextLink>}</li>)}</ul></div>;
    $[44] = isInnerPage;
    $[45] = isMobileMenuOpen;
    $[46] = t30;
  } else {
    t30 = $[46];
  }
  let t31;
  if ($[47] !== t28 || $[48] !== t29 || $[49] !== t30) {
    t31 = <div className={t28} id="mobile-menu" aria-hidden={t29}>{t30}</div>;
    $[47] = t28;
    $[48] = t29;
    $[49] = t30;
    $[50] = t31;
  } else {
    t31 = $[50];
  }
  let t32;
  if ($[51] !== t24 || $[52] !== t27 || $[53] !== t31) {
    t32 = <header className={`fixed top-0 left-0 right-0 z-2500 transition-all duration-300 ease-in-out ${"bg-fuchsia-300/80 dark:bg-gray-900/90"} backdrop-blur-xl`}>{t24}{t27}{t31}</header>;
    $[51] = t24;
    $[52] = t27;
    $[53] = t31;
    $[54] = t32;
  } else {
    t32 = $[54];
  }
  return t32;
};
export default Header;